import { createContext } from 'react';

export type QuotaResource = 'documents' | 'analysis runs' | 'extractions';

export interface QuotaBlockContextValue {
  /**
   * Inspect a caught error; if it is a server-side quota block (HTTP 402 with
   * a known quota error code), open the block dialog and return `true`.
   * Otherwise return `false` so the caller can keep its existing error flow.
   */
  readonly handleQuotaError: (error: unknown) => boolean;
  readonly openExtractionAllowanceBlock: (allowance: {
    readonly limit: number;
    readonly used: number;
    readonly requested: number;
  }) => void;
}

export const QuotaBlockCtx = createContext<QuotaBlockContextValue | null>(null);
